import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import TemplateLayout from "../../components/template-layout";
import PrivacyConsent from "../../components/privacy-consent";
import TemplateForm from "../../components/template-form/template-form";
import TemplatesTable from "../../components/templates-table/templates-table";
import GlobalThankYouTemplateForm from "../../components/global-thank-you-template-form/global-thank-you-template-form";

const TemplatePage = () => {
  return (
    <>
      <Routes>
        <Route element={<TemplateLayout />}>
          {/* default -> funnel-templates */}
          <Route index element={<Navigate to="funnel-templates" replace />} />

          <Route path="funnel-templates" element={<TemplatesTable />} />
          <Route path="funnel-templates/new" element={<TemplateForm />} />
          <Route path="funnel-templates/:id" element={<TemplateForm />} />

          <Route
            path="global-thank-you-template"
            element={<GlobalThankYouTemplateForm />}
          />
          <Route path="privacy-consent" element={<PrivacyConsent />} />
        </Route>

        <Route
          path="*"
          element={
            <Navigate to="/dashboard/templates/funnel-templates" replace />
          }
        />
      </Routes>

      <Outlet />
    </>
  );
};

export default TemplatePage;

// <Route element={<TemplateLayout />}>
//   <Route
//     index
//     path="profile"
//     element={<UserFormPage forProfileSettings />}
//   />
//   <Route path="security" element={<UserSecurity />} />
//   <Route path="change-password" element={<ChangePassword />} />
// </Route>
